import { Component, OnInit, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ViewService } from '@services/view.service';
import { SaveService } from '@services/save.service';
import { DocumentService } from '@services/document.service';
import { FormdataService } from '@services/formdata.service';
import { FormBuilder, FormGroup, FormArray, FormControl } from '@angular/forms';
import { CategoryService } from '@services/category.service';
import * as _ from 'lodash';
import { CommonPipe } from '@pipes/common.pipe';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { MapsAPILoader } from "@agm/core";
import { google } from "google-maps";
declare var google: google;
import { CATEGORYEDIT } from '@category/sra_category_edit';
import { Helper } from '@category/helper';
import { CategoryRelatedService } from '@services/category-related.service';
import * as $ from "jquery";
@Component({
  selector: 'app-ebusiness',
  templateUrl: './ebusiness.component.html',
  styleUrls: ['./ebusiness.component.sass']
})
export class EbusinessComponent implements OnInit {

  pathToMedia: any = {};
  response: any = [];
  country_list: any = [];
  image_paths: any = [];
  selected_category = "";
  params: any = [];
  status_list: any = [];
  status_txt = '';
  user_refresh: any = [];
  btn_process = false;
  appEditForm: FormGroup;
  final_hour: any = [];
  weekday: any = [];
  hours_start: any = [];
  hours_end: any = [];
  day: any = [];
  isClosed = "";
  isClaimed: boolean;
  error: any = { 'custom': '', 'name': '', 'email': '', city: '', state: '', zip: '', address: '', country: '', 'streetAddress': '', isClosed: '', isClaimed: '', phone: '', fax: '' };
  columns:any=[];
  application = "business";
  component = "b";
  country = "";
  country_code = "";
  public config: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    maxFiles: 1
  };
  public config1: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
  };
  public dvconfig: DropzoneConfigInterface = {
    acceptedFiles: '.mp4',
    clickable: true,
    dictDefaultMessage: "Click or drag video here to upload",
    maxFiles: 1
  };
  public docconfig: DropzoneConfigInterface = {
    acceptedFiles: '.pdf,.docx,doc',
    clickable: true,
    maxFiles: 1,
    dictDefaultMessage: "Click or drag document here to upload",
  };
  public dpconfig: DropzoneConfigInterface = {
    acceptedFiles: 'image/*',
    clickable: true,
    maxFiles: 1,
    dictDefaultMessage: "Click or drag photo here to upload",
  };
  public daconfig: DropzoneConfigInterface = {
    acceptedFiles: 'audio/*',
    clickable: true,
    maxFiles: 1,
    dictDefaultMessage: "Click or drag audio here to upload",
  };
  hour_start: '';
  loading = false;
  hour_end = '';
  start = '';
  end = '';
  related_data: any = [];
  related__entity_data: any = [];
  related__entity_ids: any = [];
  relatedProductIds: any = [];
  entity_list: any = [];
  entity_association: any = [];
  entity_association_status: any = [];
  user_refresh_data: any = [];
  document_list:any=[];
  id="";
  constructor(private _docService: DocumentService, private _relatedService: CategoryRelatedService, private _cpipe: CommonPipe, private _categoryService: CategoryService, private MapsAPILoader: MapsAPILoader, private ngZone: NgZone, private fb: FormBuilder, private _saveService: SaveService, private _formdataService: FormdataService, private route: ActivatedRoute, private _global: GlobalService, private router: Router, private _viewService: ViewService) {

    let THIS = this;
    this.weekday = this._global.BUSINESS_WEEKDAY;
    this.hours_start = this._global.BUSINESS_HOURS_START;
    this.hours_end = this._global.BUSINESS_HOURS_END;
    this.appEditForm = this.fb.group({
      status: [],
      latitude: [],
      longitude: [],
      name: [],
      isClaimed: [],
      fax_dialCode: [],
      fax_no: [],
      phone_dialCode: [],
      day: [],
      cpname: [],
      cpvalue: [],
      start: [],
      end: [],
      phone_no: [],
      isClosed: [],
      email: [],
      streetAddress: [],
      address: [],
      mobileUrl: [],
      countryCode: [],
      description: [],
      hours: new FormArray([]),
      customproperty: new FormArray([]),
      city: [],
      state: [],
      zip: [],
      url: []
    });

    this.appEditForm.get('day').setValue(0);
    this.start = '0000';
    this.appEditForm.get('start').setValue('0000');
    this.end = '0000';
    this.appEditForm.get('end').setValue('00000');
    this.route.queryParams.subscribe(params => {

      this.params = params;
      this.id = this.params['id'];
      let p = {
        'component': this.component,
        'application': this.application,
        'id':this.id   
      };
      this._viewService.application(p).subscribe(
        data => {

          if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
            this.response = this._global.getVal(data, 'response', '');
            this.pathToMedia = this._global.getVal(this.response, 'pathToMedia', {});
            this.image_paths.push(this.pathToMedia);
            this.isClosed = this._global.getVal(this.response, 'isClosed', '');
            this.isClaimed = this._global.getVal(this.response, 'isClaimed', '');
            this.appEditForm.get('isClosed').setValue(this._global.getVal(this.response, 'isClosed', '').toString());
            this.appEditForm.get('isClaimed').setValue(this._global.getVal(this.response, 'isClaimed', '').toString());
            this.country_code = this._global.getVal(this.response, 'countryCode', '');
            if (this.response['hours'] && this.response['hours'][0] && this.response['hours'][0]['open']) {

              Object.entries(this.response['hours'][0]['open']).forEach(([key, value]) => {
                const hour = this.fb.group({
                  day: [value['day']],
                  start: [value['start']],
                  end: [value['end']],
                  day_txt: [this.getDay(value['day'])],
                  start_txt: [this.getSHour(value['start'])],
                  end_txt: [this.getEHour(value['end'])]
                });
                (this.appEditForm.get('hours') as FormArray).push(hour);

              });
            }
            if (this._global.getVal(this.response, 'customProperties', '') && !_.isEmpty(this._global.getVal(this.response, 'customProperties', ''))) {

              Object.entries(this._global.getVal(this.response, 'customProperties', '')).forEach(([key, value]) => {
                const c = this.fb.group({
                  name: key,
                  value: value
                });
                (this.appEditForm.get('customproperty') as FormArray).push(c);

              });
            }

            let pa = {
              entityId: this.response.id,
              application: this.application,
              component: this.component
            };
            this._docService.document(pa).subscribe(
              data => {
        
                if (!_.isEmpty(this._global.getVal(data, 'response.docs', ''))) {
                  this.document_list=this._global.getVal(data, 'response.docs', '');
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });
              let f = {
                'component': this.component,
                'application': this.application
              };

          /* 
            this._formdataService.listStatusTypes(f).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  this.status_list.push({ label: 'Select Status', value: null });
                  for (let s in result) {
                    this.status_list.push({ label: result[s]["name"], value: result[s]["value"] });
                  }
                  this.appEditForm.get('status').setValue(this.response.status);
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              }); */

            this._formdataService.countries(f).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                 this.country_list = this._global.getVal(data, 'response', '');
                  this.appEditForm.get('countryCode').setValue(this._global.getVal(this.response, 'countryCode', ''))
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

            let p = {
              'component': this.component,
              'application': 'category',
              'categoryType': this.application
            };
            this._categoryService.application(p).subscribe(
              data => {
                if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
                  let result = this._global.getVal(data, 'response', '');
                  CATEGORYEDIT.init(result, '#' + this.application + '_category', true, "categoryTree", this.response.category, this.application, true);
                  CATEGORYEDIT.init(result, '#entity_category', false, "entityTree", '', this.application, true);
                  $("div#" + this.application + "_category").click(function (e) {
                    var $target = $(e.target);
                    if ($target.attr("id") === "categoryCheck") {
                      //  let result = Helper.getCategoryChecboxValues("categoryCheck", '');
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                  $("div#" + this.application + "_category ul li input").each(function (e) {
                    var $target = $(this);
                    if ($target.attr("id") === "categoryCheck") {
                      THIS.selected_category = Helper.categoryJsonText("categoryCheck");
                    }
                  });
                }
              },
              error => {
                console.log("error", JSON.stringify(error));
              });

          }
        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    });

    this.columns = [
      { header: 'Name', field: 'name' },
      { header: 'Media', field: 'pathToMedia' },
    ];

  }

  @ViewChild('streetAddress') public addressElement: ElementRef;
  @ViewChild('logo') public logo: ElementRef;
  ngOnInit() {
  }

 
  getAddress() {
    let THIS = this;
    console.log("his.addressElement.nativeElement", this.addressElement.nativeElement);
    this.MapsAPILoader.load().then(
      () => {
        let automcomplete = new google.maps.places.Autocomplete(this.addressElement.nativeElement, { types: ["address"], componentRestrictions: { country: THIS.country_code } });

        console.log("automcomplete", automcomplete);
        automcomplete.addListener("place_changed", () => {

          let p = this.ngZone.run(() => {
            let place: google.maps.places.PlaceResult = automcomplete.getPlace();
            if (place.geometry == undefined || place.geometry == null) {
              //return place;
            } else {

              let address = place.address_components;
              let geometry = place.geometry;
              let THIS = this;
              THIS.appEditForm.get('streetAddress').setValue(place["formatted_address"]);
              address.forEach(function (value) {
                if (value["types"][0] == 'country') {
                  //  THIS.country_code= value["short_name"];
                  // THIS.appEditForm.get('country').setValue( THIS.country_code);

                } else if (value["types"][0] == 'locality') {
                  THIS.appEditForm.get('city').setValue(value["long_name"]);
                } else if (value["types"][0] == 'administrative_area_level_1') {
                  THIS.appEditForm.get('state').setValue(value["long_name"]);
                } else if (value["types"][0] == 'postal_code') {
                  THIS.appEditForm.get('zip').setValue(value["long_name"]);
                }
              });
              if (geometry) {
                var lat = geometry.location.lat();
                var lng = geometry.location.lng();
                THIS.appEditForm.get('latitude').setValue(lat);
                THIS.appEditForm.get('longitude').setValue(lng);

              }
              //   return place;
            }
          })
        })
      }
    )
  }

  update() {
    this.error = { 'custom': '', 'name': '', 'email': '', city: '', state: '', zip: '', address: '', country: '', 'streetAddress': '', isClosed: '', isClaimed: '', phone: '', fax: '' };

    let res = this.country_list.find(x => x.value == this.country_code);
    this.country = "";
    if (res) {
      this.country = res["label"];
    }
    this.btn_process = true;
    let params = this.appEditForm.value;
    let r = this._global.generateParams(params, ['customproperty', 'cpname', 'cpvalue', 'day', 'start', 'end', 'phone_dialCode', 'fax_dialCode', 'fax_no', 'latitude', 'longitude', 'phone_no']);
    r['component'] = this.component;
    r['application'] = this.application;
    let p = this._global.paramsRemoveNull(r);
    p.categoryJson = Helper.getCategoryChecboxValues("categoryCheck", '');

    let hour = {};
    let open = [];
    let result = [];
    Object.entries(this.appEditForm.value['hours']).forEach(([key, value]) => {
      let hours = {};
      hours["is_overnight"] = "false";
      hours["day"] = value['day'];
      hours["start"] = value['start'];
      hours["end"] = value['end'];
      result.push(open.push(hours));
    });
    hour["open"] = open;
    this.final_hour.push(hour);
    p.hours = JSON.stringify(this.final_hour);

    let custom = {};
    Object.entries(this.appEditForm.value['customproperty']).forEach(([key, value]) => {
      custom[value['name']] = value['value'];
    });
    p.customProperties = JSON.stringify(custom);

    let addressJson = {};
    addressJson["streetAddress"] = p.streetAddress;
    addressJson["address"] = p.address;
    addressJson["city"] = p.city;
    addressJson["state"] = p.state;
    addressJson["country"] = this.country;
    addressJson["zip"] = p.zip;
    addressJson["latitude"] = p.latitude;
    addressJson["longitude"] = p.longitude;
    p.addressJson = JSON.stringify(addressJson);
    let phone = { "phone": {} };
    phone["phone"]["area"] = params.phone_dialCode;
    phone["phone"]["number"] = params.phone_no
    var fax = { "fax": {} };
    fax["fax"]["area"] = params.fax_dialCode;
    fax["fax"]["number"] = params.fax_no;
    p.phone = JSON.stringify(phone);
    p.fax = JSON.stringify(fax);
    p.country = this.country;
    p.id = this.response.id;
    p.status=this.response.status;
    if (!_.isEmpty(params.latitude) && !_.isEmpty(params.longitude)) {
      let latlongs = {};
      latlongs["lat"] = params.latitude;
      latlongs["lon"] = params.longitude;
      p.latlong = JSON.stringify(latlongs);
    }
    p.pathToMedia = JSON.stringify(this.pathToMedia);

    this._saveService.appUpdate(p).subscribe(
      data => {
        console.log("data", data);
        let severity = 'success';
        let message = '';
        if (this._global.getVal(data, 'status', '') == 1) {
          message = this._global.getVal(data, 'message.info', '');
          this._global.showMessage({ severity: severity, message: message });
          this.router.navigate(['/my/'+ this.application]);
        } else {
          this.btn_process = false;
          message = this._global.getVal(data, 'message.error', '');
          severity = 'error';
          for (let key in data["errors"]) {

            this.error[key] = this._global.getVal(data, 'errors.' + key + '.message', '');

          }
          this._global.showMessage({ severity: severity, message: message });
        }

      },
      error => {
        console.log("error", JSON.stringify(error));
      });


  }
  removeHour(index) {
    (this.appEditForm.get('hours') as FormArray).removeAt(Number(index));
  }
  removeCP(index) {
    (this.appEditForm.get('customproperty') as FormArray).removeAt(Number(index));
  }
  addCustom() {

    const cp = this.fb.group({
      name: [this.appEditForm.value['cpname']],
      value: [this.appEditForm.value['cpvalue']]
    });
    if (!_.isEmpty(this.appEditForm.value['cpname']) && this.appEditForm.value['cpvalue']) {
      this.error['custom'] = '';
      this.appEditForm.get('cpname').setValue('');
      this.appEditForm.get('cpvalue').setValue('');
      (this.appEditForm.get('customproperty') as FormArray).push(cp);
    } else {
      this.error['custom'] = 'Enter custom  name and value ';
    }


  }
  addHours() {
    const day = this.weekday.find(x => x.value == this.appEditForm.value['day']);
    const start = this.hours_start.find(x => x.value == this.start);
    const end = this.hours_end.find(x => x.value == this.end);
    const hour = this.fb.group({
      day: [this.appEditForm.value['day']],
      start: [this.start],
      end: [this.end],
      day_txt: [day['label']],
      start_txt: [start['label']],
      end_txt: [end['label']]
    });
    (this.appEditForm.get('hours') as FormArray).push(hour);
    let d = this.appEditForm.value['day'];
    if (d == 6) {
      d = 0;
    } else {
      d = parseInt(d) + 1;
    }
    this.appEditForm.get('day').setValue(d);
  }
  getDialCode(event) {
    let res = this.country_list.find(x => x.value == event.value);
    if(res){
    this.country = res["label"];
    this.country_code = this.appEditForm.value["countryCode"];
    let p = {
      'component': this.component,
      'application': this.application,
      'countryCode': this.country_code
    };
    this._formdataService.dialCode(p).subscribe(
      data => {
        if (!_.isEmpty(this._global.getVal(data, 'response', ''))) {
          this.appEditForm.get('phone_dialCode').setValue(this._global.getVal(data, 'response.dialCode', ''));
          this.appEditForm.get('fax_dialCode').setValue(this._global.getVal(data, 'response.dialCode', ''));
        }
      },
      error => {
        console.log("error", JSON.stringify(error));
      });
    }
  }
  returnZero() {
    return 0
  }
  getDay(d) {
    const day = this.weekday.find(x => x.value == d);
    return day['label'];
  }
  getSHour(h) {
    const start = this.hours_start.find(x => x.value == h);
    return this._global.getVal(start, 'label', '');
  }
  getEHour(h) {
    const end = this.hours_end.find(x => x.value == h);
    return this._global.getVal(end, 'label', '');
  }
  conUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this.id);
 
  }
  conUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });

  }
  public conUploadSuccess(args: any): void {
    this.logo.nativeElement.src = this._cpipe.transform(this.response, ['image', this.application, 'id', 'title', 'm']);
  }



  public onUploadInit(args: any): void {
    args["options"]["params"] = this._global.getUploadParams(this.application, this.component,'photo', '');
  }
  public onUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }

  public onUploadSuccess(args: any): void {
    let res = JSON.parse(args[1]);
    this.pathToMedia[res['id']] = this._global.getUploadPathToMedia(res);

  } 
  removeImg(id) {
    if (this.image_paths[0]) {
      this.pathToMedia = this._global.removePathToMediaImage(this.pathToMedia, id);
      this.image_paths = [];
      this.image_paths.push(this.pathToMedia);
    }
  }

  chooseRelated(obj) {
    let r = this.relatedProductIds.find(x => x.value == obj.value);
    if (!r) {
      this.relatedProductIds.push(obj);
    }

  }
  removeRelated(obj) {
    this.relatedProductIds = this.relatedProductIds.filter(item => item.value != obj.value);
  }
  chooseEntityRelated(a, obj) {
    let r = this.related__entity_ids[a].find(x => x.value == obj.value);
    if (!r) {
      this.related__entity_ids[a].push(obj);
    }
  }
  removeEntityRelated(a, obj) {
    this.related__entity_ids[a] = this.related__entity_ids[a].filter(item => item.value != obj.value);
  }
  onDvUploadInit(event) {

  }
  onDaUploadInit(event) {

  }
  onDvUploadError(event) {

  }
  onDaUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });

  }
  onDvUploadSuccess(event) {

  }
  onDaUploadSuccess(event) {

  }

  onDocUploadInit(event) {

  }
  onDpUploadInit(args) {
   // args["options"]["params"] = this._global.getUploadParams(this.application, this.component, this.application, this.user_refresh_data, '');

  }
  onDocUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }
  onDpUploadError(args: any): void {
    this._global.showMessage({ type: 'warning', message: args[1] });
  }
  onDocUploadSuccess(event) {

  }
  onDpUploadSuccess(args) {
    let res = JSON.parse(args[1]);
    let path = {};
    if (this._global.getVal(res,'id','')) {
      path[res['id']] = this._global.getUploadPathToMedia(res);
      let p = {
        entityId: this.response.id,
        status: "active",
        name: res['name'],
        pathToMedia: JSON.stringify(path),
        extension: "png",
        mediaType: "photo",
        application: this.application,
        docType: this.application,
        component: this.component
      };
      this._docService.create(p).subscribe(
        data => {


        },
        error => {
          console.log("error", JSON.stringify(error));
        });
    }

  }

}

